import { render, staticRenderFns } from "./awardsForm.vue?vue&type=template&id=2ec6cdbd&scoped=true&"
import script from "./awardsForm.vue?vue&type=script&lang=js&"
export * from "./awardsForm.vue?vue&type=script&lang=js&"
import style0 from "./awardsForm.vue?vue&type=style&index=0&id=2ec6cdbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec6cdbd",
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QInput,QSelect,QCheckbox});
